(function componentForm($, Adzuki)
{
	"use strict";

	var form = {
		name: 'ClientLead',
	};

	$(document).ready(function documentReady()
	{
		Adzuki.Form.registerForm(form);
	});

	form.load = function load()
	{
		$(document).bind('drag-drop-files-changed', function attachmentsChanged(e, data) {
			$('#clientlead-attachments_changed').val(1);
		});

		loadRequiredFields();
		setRequiredFields();
		loadLabels();

		$('.fields').click(function checkedBox() {
			if ($(this).prop('checked') === true) {
				addRequiredField($(this));
			} else {
				// eslint-disable-next-line no-lonely-if
				if (!$(this).hasClass('disabled')) {
					$('#container-' + $(this).val()).remove();
				}

				// unchecked the mobile phone field, the optin for texts
				// fields must also be unchecked
				if ($(this).val() === 'mobile_phone') {
					$('.fields').each(function onEachCheckbox(i, elem) {
						if (
							$(elem).is(':checked')
							&& (
								$(elem).val() === 'mobile_receive_texts' ||
								$(elem).val() === 'mobile_receive_travel_texts' ||
								$(elem).val() === 'mobile_receive_fit_builder_texts'
							)
						) {
							// trigger the click that will uncheck it
							$(elem).trigger('click');
						}
					});
				}
			}
		});

		$('#clientlead-template_id').change(function loadTemplate() {
			var template_id = $(this).val();

			document.location = Adzuki.base_uri + '/ClientLeadForms/add/' + template_id;
		});

		$('#clientlead-send_email_client').click(function showHideClient() {
			if ($(this).prop('checked') === true) {
				$('.client-email').removeClass('hidden');
			} else {
				$('.client-email').addClass('hidden');
			}
		});

		$('#clientlead-send_email').click(function showHide() {
			if ($(this).prop('checked') === true) {
				$('.contact-email').removeClass('hidden');
			} else {
				$('.contact-email').addClass('hidden');
			}
		});

		$('.required-fields').on('click', '.requireds', function showRequiredAsterisk() {
			var id = $(this).attr('id'),
				field_name = id.replace('field-', 'required-');

			if ($(this).prop('checked') === true) {
				$('#' + field_name).css('visibility', 'visible');
			} else {
				$('#' + field_name).css('visibility', 'hidden');
			}
		});

		$('a.create-segment, a.select-segment').click(function _toggleSegment(e) {
			e.preventDefault();
			$(".segments-new").toggleClass('hidden').find('input[type="text"]').val('');

			$(".segments-existing")
				.toggleClass('hidden')
				.find('select')
				.selectpicker('deselectAll');
		});

		$('a.create-status, a.select-status').click(function _toggleStatus(e) {
			e.preventDefault();
			$(".status-new").toggleClass('hidden').find('input').val('');
			$(".status-existing").toggleClass('hidden').find('select').val('');
		});

		// Used by custom thank you page content WYSIWYG
		if ($('#clientlead-create_action').val() === '1') {
			Adzuki.Editor('#clientlead-post_submit_page_content', {
				init_instance_callback: function onEditorInit(_editor) {
					let default_content = 'Thank you so much for sharing your desire to learn more about fabulous vacation opportunities provided by Cruise Planners! Remember we not only sell more cruises than just about anyone, but we also are experts and top sellers of All Inclusive Resorts, Hotels, Escorted Tours and customized trips. I am excited to learn more about how I can help you plan your next dream vacation! To make sure I send you what you may be most interested in, please click on the link below for our Where2Next Survey. This short survey will allow me to personalize our communications to you so we can work together to find the perfect choice for your next vacation!\n'
						+ '<a href="'+ Adzuki.base_uri +'/Where2Next" target="_blank">Where2Next Survey</a>';
					_editor.setContent('<p>' + default_content + '</p>');
				},
			});
		}

		$('#clientlead-exclude_navigation').change(function checkBoxChanged() {
			if (this.checked) {
				$('#post_submit_section').attr('disabled', 'disabled');
				$('#clientlead-custom_post_submit_page').prop("checked", 0).change();
				$('#post_submit_page_content_message').removeClass('hidden');
			} else {
				$('#post_submit_section').removeAttr('disabled');
				$('#post_submit_page_content_message').addClass('hidden');
			}
		});

		$('#clientlead-custom_post_submit_page').change(function checkBoxChanged() {
			if (this.checked) {
				$('#post_submit_section__page_content').removeClass('hidden');
				$('#redirect_section').addClass('hidden');
			} else {
				$('#post_submit_section__page_content').addClass('hidden');
				$('#redirect_section').removeClass('hidden');
			}
		});

		$('#include_where2next_button').click(function appendEditor(e) {
			e.preventDefault();
			Adzuki.Editor('#clientlead-email_message', {
				init_instance_callback: function onEditorInit(_editor) {
					let default_content = $('#cp-where2next-content').html();
					let editor_content  = _editor.getContent();
					_editor.setContent(editor_content + default_content);
					$('#clientlead-email_message').val(_editor.getContent());
				}
			});
		});

		$('#include_cp_mobile_info_button').click(function appendEditor(e) {
			e.preventDefault();
			Adzuki.Editor('#clientlead-email_message', {
				init_instance_callback: function onEditorInit(_editor) {
					let default_content = $('#cp-mobile-information-content').html();
					let editor_content  = _editor.getContent();
					_editor.setContent(editor_content + default_content);
					$('#clientlead-email_message').val(_editor.getContent());
				}
			});
		});

		$('#clientlead-website_page_redirect').change(function handle() {
			if ($(this).is(':checked')) {
				$('#internal_redirect_section').removeClass('hidden');
			} else {
				$('#internal_redirect_section').addClass('hidden');
			}
		});
	};

	function addRequiredField($ojb)
	{
		var html = createInput(
			$ojb.val(),
			$ojb.data("name"),
			false,
			'<span class="required required-field-indicator" id="required-' + $ojb.val() + '"></span>',
			($ojb.data('type') === 'checkbox' ? 'disabled' : '')
		);

		$('.required-fields').append(html);
	}

	function createInput(value, name, checked, required, disabled)
	{
		var name_modified  = name.replace(/<\/?[^>]+(>|$)/g, ""),
			html           = '',
			required_val   = required,
			style          = 'width: 300px;height: 34px;padding: 6px 12px;font-size: 14px;color: #555555;background-color: #fff;background-image: none;border-radius: 4px;box-shadow: inset 0 1px 1px rgba(0,0,0,0.075);transition: border-color ease-in-out .15s, box-shadow ease-in-out .15s, -webkit-box-shadow ease-in-out .15s;',
			not_changeable = $.parseJSON($('#clientlead-not_changeable').val());

		name_modified = name_modified.trim();

		if (disabled === 'disabled') {
			required_val = '<span class="required required-field-indicator" id="required-email" style="visibility: hidden;"></span>';
		}

		if (not_changeable.indexOf(value) >= 0) {
			// eslint-disable-next-line no-param-reassign
			disabled = 'disabled';
		} else {
			// eslint-disable-next-line no-param-reassign
			disabled = '';
		}

		// hacky ish for someone wanting a special label for weekly travel deal optin field
		if (value === 'optin_date') {
			name_modified = 'I look forward to getting emails about fabulous vacations, trips, and offers!';
		}

		// create the input html
		html = '<div class="checkbox" id="container-' + value +'" style="padding-bottom: 10px;"><label><input ' + disabled + ' id="field-' + value + '" value="' + value + '" checked="' + checked + '" class="requireds" type="checkbox" name="form_component_data[ClientLead][requireds][]" style="margin-top: 10px;">' + required_val + ' <input id="textfield-' + value +'" style="' + style +'" type="text" value="' + name_modified +'" name="form_component_data[ClientLead][labels][' + value + ']">&nbsp;&nbsp;<strong>CP Maxx Label:</strong>&nbsp;' + name + '</label></div>';

		return html;
	}

	function loadRequiredFields()
	{
		var html            = '',
			sorted_order    = $('#clientlead-sorted_fields').val(),
			selected_fields = $('#clientlead-selected_fields').val(),
			checked_fields  = [],
			placed_in_sort  = [],
			$checkbox;

		// if there has been a sort order set
		if (sorted_order.length > 0) {
			selected_fields = $.parseJSON(selected_fields);

			// if there has been fields already selected, add them to an array
			if (selected_fields.length > 0) {
				selected_fields.forEach(function loopOverSelectedFields(index, key) {
					checked_fields.push(index);
				});
			}

			sorted_order    = $.parseJSON(sorted_order);

			// iterate over the sort order and add the fields to the screen based on the sort
			sorted_order.forEach(function applySort(index, key) {
				placed_in_sort.push(index);
				$checkbox = $('.fields[value="' + index + '"]');

				if (checked_fields.includes(index)) {
					html += createInput(
						$checkbox.val(),
						$checkbox.data("name"),
						true,
						'<span class="required required-field-indicator" id="required-' + $checkbox.val() + '"></span>',
						($checkbox.data('type') === 'checkbox' ? 'disabled' : '')
					);
				}
			});

			// if there were fields that had not been sorted, add them at the end
			selected_fields.forEach(function loopOverSelectedFieldsAgain(index, key) {
				$checkbox = $('.fields[value="' + index + '"]');

				if (!placed_in_sort.includes(index)) { // check to make sure they weren't in the sort
					html += createInput(
						$checkbox.val(),
						$checkbox.data("name"),
						true,
						'<span class="required required-field-indicator" id="required-' + $checkbox.val() + '"></span>',
						($checkbox.data('type') === 'checkbox' ? 'disabled' : '')
					);
				}
			});
		} else { // for adding new or when no sort was applied
			$('.fields').each(function getRequiredFields() {
				if ($(this).prop('checked') === true) {
					html += createInput(
						$(this).val(),
						$(this).data("name"),
						true,
						'<span class="required required-field-indicator" id="required-' + $(this).val() + '"></span>',
						($(this).data('type') === 'checkbox' ? 'disabled' : '')
					);
				}
			});
		}

		$('.required-fields').html(html);
	}

	function loadLabels()
	{
		var label_field = $('#clientlead-labels').val(),
			labels;

		if (label_field.length > 0) {
			labels = $.parseJSON(label_field);

			$.each(labels, function label(key, value) {
				$('#textfield-' + key).val(value);
			});
		}
	}

	function setRequiredFields()
	{
		var required_fields_json = $('#clientlead-required_fields').val(),
			required_fields;

		if (required_fields_json.length > 0) {
			required_fields = $.parseJSON($('#clientlead-required_fields').val());

			$('.requireds').each(function unCheckem() {
				$(this).prop('checked', false);
			});

			$('.required-field-indicator').each(function unDoit() {
				$(this).css('visibility', 'hidden');
			});

			$.each(required_fields, function thing(index, element) {
				$('.requireds').each(function checkem() {
					if ($(this).attr('id') === 'field-' + element) {
						$(this).prop('checked', true);
						$('#required-' + element).css('visibility', 'visible');
					}
				});
			});
		}
	}
}(jQuery, window.Adzuki || {}));
